import {JsonProperty} from '@hyperloris/tyson';
import {FieldRecord} from "./field-record";
import {SyncMetadata} from "./sync-metadata";

export class FieldResult<T> {

  @JsonProperty()
  success: boolean = false;

  @JsonProperty()
  message: string | undefined;

  @JsonProperty()
  records: FieldRecord<T>[];

}

